import { render, staticRenderFns } from "./statusEchart.vue?vue&type=template&id=2b664844&scoped=true&"
import script from "./statusEchart.vue?vue&type=script&lang=js&"
export * from "./statusEchart.vue?vue&type=script&lang=js&"
import style0 from "./statusEchart.vue?vue&type=style&index=0&id=2b664844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b664844",
  null
  
)

export default component.exports